export default __webpack_public_path__ + "static/logo2-a48e56a27c9241764875b919e8989f83.svg";